__turbopack_context__.v({
  "arrow": "SearchResultsSection-module-scss-module__p7tODG__arrow",
  "avatar": "SearchResultsSection-module-scss-module__p7tODG__avatar",
  "contentWrapper": "SearchResultsSection-module-scss-module__p7tODG__contentWrapper",
  "foundItem": "SearchResultsSection-module-scss-module__p7tODG__foundItem",
  "header": "SearchResultsSection-module-scss-module__p7tODG__header",
  "list": "SearchResultsSection-module-scss-module__p7tODG__list",
  "matchRow": "SearchResultsSection-module-scss-module__p7tODG__matchRow",
  "matchType": "SearchResultsSection-module-scss-module__p7tODG__matchType",
  "matches": "SearchResultsSection-module-scss-module__p7tODG__matches",
  "name": "SearchResultsSection-module-scss-module__p7tODG__name",
  "postDetails": "SearchResultsSection-module-scss-module__p7tODG__postDetails",
  "text": "SearchResultsSection-module-scss-module__p7tODG__text",
  "type": "SearchResultsSection-module-scss-module__p7tODG__type",
});
